import { FormControl, InputLabel } from '@mui/material';

import { MyMenuItem, MySelect } from "~/mui/MySelect";

import "./style.less";

export type TExportType = "invoice" | "complete";

interface IBillingExportSelect {
	selected: TExportType;
	onChange: (value: TExportType) => void;
}

export default function BillingExportSelect({
	selected,
	onChange = () => {},
}: IBillingExportSelect) {
	return <FormControl size="small">
		<InputLabel>Typ Exportu</InputLabel>
		<MySelect
			value={selected}
			onChange={event => onChange(event.target.value as TExportType)}
			label="Typ Exportu"
		>
			<MyMenuItem value="invoice">Export pro fakturaci</MyMenuItem>
			<MyMenuItem value="complete">Kompletní export</MyMenuItem>
		</MySelect>
	</FormControl>;
}
